import React, { useEffect, useState } from "react";
import {
    BadgePercent,
    Clock3,
    FileText,
    Landmark,
    ShieldCheck,
    CreditCard,
} from "lucide-react";
import ParamCotisationsPaie from "./ParamCotisationsPaie";
import PaieReferentielPage from "./PaieReferentielPage";
import ParamRemunerations from "./ParamRemunerations";
import "./ParametresPaiePage.css";

const TABS = [
    {
        key: "cotisations",
        label: "Cotisation",
        icon: ShieldCheck,
        render: () => <ParamCotisationsPaie />,
    },
    {
        key: "bareme-ir",
        label: "Barèmes IR",
        icon: Landmark,
        render: () => <PaieReferentielPage resource="baremesIr" />,
    },
    // {
    //     key: "remunerations",
    //     label: "Banques & RIB",
    //     icon: CreditCard,
    //     render: () => <ParamRemunerations />,
    // },
    {
        key: "heures-supplementaires",
        label: "Heures supplémentaires",
        icon: Clock3,
        render: () => <PaieReferentielPage resource="typesHeuresSupplementaires" />,
    },
    {
        key: "frais-professionnels",
        label: "Frais professionnels",
        icon: FileText,
        render: () => <PaieReferentielPage resource="baremesFraisProfessionnels" />,
    },
];

const isValidTab = (tabKey) => TABS.some((tab) => tab.key === tabKey);

const ParametresPaiePage = ({ initialTab = "cotisations" }) => {
    const [activeTab, setActiveTab] = useState(isValidTab(initialTab) ? initialTab : "cotisations");

    useEffect(() => {
        if (isValidTab(initialTab)) {
            setActiveTab(initialTab);
        }
    }, [initialTab]);

    const selectedTab = TABS.find((tab) => tab.key === activeTab) || TABS[0];

    return (
        <div className="ppp-page">
            <div className="ppp-header">
                <div>
                    <h1><BadgePercent size={20} />Paramètres de compensation</h1>
                    <p>Gérez les paramètres de cotisations, barèmes fiscaux, heures supplémentaires et frais professionnels depuis une seule interface.</p>
                </div>
            </div>

            <div className="ppp-tabs" role="tablist" aria-label="Parametres paie">
                {TABS.map((tab) => {
                    const Icon = tab.icon;
                    const active = tab.key === activeTab;
                    return (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={active}
                            className={`ppp-tab ${active ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            <Icon size={16} />
                            <span>{tab.label}</span>
                        </button>
                    );
                })}
            </div>

            <div className="ppp-panel" role="tabpanel">
                {selectedTab.render()}
            </div>
        </div>
    );
};

export default ParametresPaiePage;
